import { TextInput } from "../../components";
import { Typography, Checkbox } from "antd";

const { Title } = Typography;

const PureCreateProfile = () => {
  return (
    <>
      <Title level={3}> Create your Profile </Title>
      <Title level={5}> Lets get you all set up </Title>
      <form className="mt-10 text-center">
        <div
          className="block lg:grid grid-cols-2 grid-rows-1 mt-10 mb-5"
          style={{ gap: "4.5rem" }}
        >
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="Micheal"
              type="text"
              size="middle"
              name="username"
              label="First Name"
              required
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
          </div>
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="Christain"
              type="text"
              size="middle"
              label="Last Name"
              required
              name=""
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
          </div>
        </div>
        <div
          className="block lg:grid grid-cols-2 grid-rows-1 mb-5"
          style={{ gap: "4.5rem" }}
        >
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="@michealc"
              type="text"
              size="middle"
              name="username"
              label="Username"
              required
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
          </div>
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="Christain"
              type="text"
              size="middle"
              label="Phone No"
              required
              name=""
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
          </div>
        </div>
        <div
          className="block lg:grid grid-cols-2 grid-rows-1 mb-5"
          style={{ gap: "4.5rem" }}
        >
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="Male"
              type="text"
              size="middle"
              name="username"
              label="Gender"
              required
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
          </div>
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="dd/mm/yyyy"
              type="text"
              size="middle"
              label="Date of Birth"
              required
              name=""
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
          </div>
        </div>
        <div
          className="block lg:grid grid-cols-2 grid-rows-1 mb-5"
          style={{ gap: "4.5rem" }}
        >
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="**********"
              type="text"
              size="middle"
              name="username"
              label="Password"
              required
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
            <p className="text-left pt-1">
              Password should contain at least 8 letters
            </p>
          </div>
          <div className="mb-5 lg:mb-0">
            <TextInput
              placeholder="**********"
              type="text"
              size="middle"
              label="Confirm Password"
              required
              name=""
              style={{
                padding: "15px",
                background: "#efefef",
                borderRadius: "5px",
                border: "1px solid #efefef",
              }}
            />
          </div>
        </div>
        <div className="text-left mt-10">
          <Checkbox>
            <p>
              I agree to the <a>Terms Privacy Policy</a>
            </p>
          </Checkbox>
        </div>
      </form>
    </>
  );
};

export default PureCreateProfile;
